<template>
  <v-menu rounded="lg" offset-y class="menu">
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        color="white accent-4"
        elevation="0"
        class="menu-button mr-2"
        v-bind="attrs"
        small
        v-on="on"
      >
        <v-icon left>
          mdi-text
        </v-icon>
        Ordenar por
      </v-btn>
    </template>

    <v-list>
      <v-list-item link @click="$emit('change', sortOrder.DESC)">
        <v-list-item-title
          v-text="'Mais recentes primeiro'"
          :class="{
            select: order === sortOrder.DESC,
          }"
        />
      </v-list-item>
      <v-list-item
        link
        @click="$emit('change', sortOrder.ASC)"
        :class="{
          select: order === sortOrder.ASC,
        }"
      >
        <v-list-item-title v-text="'Mais antigas primeiro'" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { sortOrder } from '@/utils/mappers.js';
export default {
  name: 'HomeSearchMenuOrder',
  props: {
    order: String,
  },
  data() {
    return { sortOrder };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/inputs.scss';

.menu {
  background-color: $color-background !important;
}
.menu-button {
  color: $color-black-64;
  font-weight: 500 !important;
  text-transform: initial;
}
.v-list {
  background-color: $color-background;
}

.select {
  font-weight: 600 !important;
}
</style>
